<template>
  <div class="collection-item-box" @click="$modal.open('order', order)">
    <h2 class="truncate" v-text="order.customer.name"></h2>
    <p class="text-sm" v-text="`${pickupDate}${pickupTime ? ` à ${pickupTime}` : '' }`"></p>
    <hr>
    <div class="flex justify-between">
      <div>
        <vue-tag icon="cupcake-solid">{{ order.cart.products.length }}</vue-tag>
        <vue-tag :class="paymentClass" icon="money-a-solid"></vue-tag>
        <vue-tag :class="noteClass" v-if="order.note" icon="note-information-solid"></vue-tag>
        <vue-tag :class="hasBeenGeneratedClass" v-if="order.has_been_generated" icon="scheduled-note-solid"></vue-tag>
      </div>
      <vue-tag class="font-mono tracking-wide" icon="barcode-solid">{{ order.order_number}}</vue-tag>
    </div>
  </div>
</template>

<script>
/* globals moment */
import { ucfirst } from '../../core/helpers';

export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },

  computed: {
    pickupDate() {
      return ucfirst(moment(this.order.pickup_date).format('ddd DD MMMM YYYY'));
    },

    pickupTime() {
      if (!this.order.pickup_time) {
        return null;
      }
      return moment(this.order.pickup_time, 'HH:mm:ss').format('HH:mm');
    },

    paymentClass() {
      return this.order.payment_received
        ? 'bg-green-lightest text-green-light'
        : 'bg-red-lightest text-red-light';
    },

    noteClass() {
      return 'bg-yellow-lightest text-yellow-dark';
    },

    hasBeenGeneratedClass() {
      return 'bg-blue-lightest text-blue-light';
    },
  },
};
</script>